const Backbone = require("backbone");
var ApiConfig = require("_lib/data/ApiConfig.js");

var Slot = Backbone.Model.extend({
  idAttribute: "slot_id",

  defaults: {},

  urlRoot: function () {
    return ApiConfig.getPrefix() + "/schedule/details";
  },
});

module.exports = Slot;
